import { render, staticRenderFns } from "./ResourcesNcfContent.vue?vue&type=template&id=5293c463&"
import script from "./ResourcesNcfContent.vue?vue&type=script&lang=js&"
export * from "./ResourcesNcfContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports